var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.381 5.305l-1.702-1.704c-.801-.802-2.197-.8-2.996 0l-8.17 8.18L2 18.001l6.211-1.516 8.17-8.18a2.126 2.126 0 0 0 0-3zM3.426 16.573l.828-3.575 2.742 2.745-3.57.83zm4.548-1.214l-1.328-1.33 3.51-3.513-.681-.682-3.51 3.514-1.327-1.329 5.651-5.659 3.336 3.341-5.651 5.658zM15.7 7.623L14.306 9.02 10.97 5.68l1.394-1.397a1.183 1.183 0 0 1 1.634 0L15.7 5.986a1.16 1.16 0 0 1 0 1.637z",
    fill: "#2B5672",
    fillRule: "evenodd"
  }));
};